"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TextArea = antd_1.Input.TextArea;
var DlgWhiteIpEditor = /** @class */ (function (_super) {
    __extends(DlgWhiteIpEditor, _super);
    function DlgWhiteIpEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgWhiteIpEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                messageTitle: data.messageTitle,
                messageBody: data.messageBody,
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            messageTitle: "",
            messageBody: "",
        });
        this.doReSetRules();
    };
    DlgWhiteIpEditor.prototype.doReSetRules = function () {
        this.setState({
        // amount_rules: {isError: false },
        });
    };
    DlgWhiteIpEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgWhiteIpEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        return true;
    };
    DlgWhiteIpEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.messageTitle, this.state.messageBody);
            }
        }
    };
    DlgWhiteIpEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgWhiteIpEditor.prototype.onMessageTitleChange = function (e) {
        this.props.controller.SetMessageTitle(e.target.value);
    };
    //private onPromoCodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    //    this.props.controller.SetPromoCode(e.target.value)
    //}
    DlgWhiteIpEditor.prototype.onMessageBodyChange = function (e) {
        this.props.controller.SetMessageBody(e.target.value);
    };
    //private onIsUsePromoCodeChange(checked: boolean) {
    //    this.props.controller.SetIsHasPromoCode(checked)
    //}
    //private onIsImportantChange(checked: boolean) {
    //    this.props.controller.SetIsImportant(checked)
    //}
    DlgWhiteIpEditor.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 300 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "Ip \u0430\u0434\u0440\u0435\u0441"),
                React.createElement(antd_1.Input, { onChange: this.onMessageTitleChange.bind(this), value: this.state.messageTitle }),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"),
                React.createElement(TextArea, { rows: 4, onChange: this.onMessageBodyChange.bind(this), value: this.state.messageBody })));
    };
    return DlgWhiteIpEditor;
}(React.Component));
exports.default = DlgWhiteIpEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgWhiteIpEditor.tsx
// module id = 2558
// module chunks = 0